import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Back from "../components/button/back";

const AddEkskul = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    Judul: "",
    Deskripsi: "",
    Jadwal: "",
  });
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    if (selectedFile) {
      const objectUrl = URL.createObjectURL(selectedFile);
      setPreviewUrl(objectUrl);
    }
  };

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      console.error("File belum dipilih");
      return;
    }

    try {
      const formPayload = new FormData();
      formPayload.append("Judul", formData.Judul);
      formPayload.append("Deskripsi", formData.Deskripsi);
      formPayload.append("Jadwal", formData.Jadwal);
      formPayload.append("file", file);

      await axios.post(
        `${process.env.REACT_APP_API_URL}api/ekskul`,
        formPayload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setFormData({ Judul: "", Deskripsi: "", Jadwal: "" });
      setFile(null);
      setPreviewUrl(null);
      navigate("/admin/ekstrakulikuler");
    } catch (error) {
      console.error("Gagal menambahkan ekskul:", error);
    }
  };

  return (
    <div className="container mx-auto mt-10 px-4 sm:px-8">
      <h2 className="text-2xl font-bold mb-5 text-center sm:text-left">
        Tambah Ekskul
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="mb-4">
          <label
            className="block text-sm font-bold mb-2 text-gray-700"
            htmlFor="Judul"
          >
            Judul
          </label>
          <input
            type="text"
            name="Judul"
            value={formData.Judul}
            onChange={handleChange}
            required
            className="border rounded w-full py-2 px-3 text-gray-700 shadow"
          />
        </div>

        <div className="mb-4">
          <label
            className="block text-sm font-bold mb-2 text-gray-700"
            htmlFor="file"
          >
            Gambar / Video
          </label>
          <input
            type="file"
            accept="image/*,video/mp4"
            onChange={handleFileChange}
            required
            className="border rounded w-full py-2 px-3 text-gray-700 shadow"
          />
        </div>

        {/* 👁️ Preview */}
        {previewUrl && (
          <div className="mb-4">
            <label className="block text-sm font-bold mb-2 text-gray-700">
              Preview
            </label>
            {file.type.startsWith("image/") ? (
              <img
                src={previewUrl}
                alt="Preview"
                className="w-full max-w-sm rounded shadow"
              />
            ) : (
              <video
                src={previewUrl}
                controls
                className="w-full max-w-sm rounded shadow"
              />
            )}
          </div>
        )}

        <div className="mb-4">
          <label
            className="block text-sm font-bold mb-2 text-gray-700"
            htmlFor="Deskripsi"
          >
            Deskripsi
          </label>
          <textarea
            name="Deskripsi"
            value={formData.Deskripsi}
            onChange={handleChange}
            rows="4"
            required
            className="border rounded w-full py-2 px-3 text-gray-700 shadow"
          ></textarea>
        </div>

        <div className="mb-4">
          <label
            className="block text-sm font-bold mb-2 text-gray-700"
            htmlFor="Jadwal"
          >
            Jadwal (Opsional) contoh (Senin dan kamis)
          </label>
          <input
            type="text"
            name="Jadwal"
            value={formData.Jadwal}
            onChange={handleChange}
            className="border rounded w-full py-2 px-3 text-gray-700 shadow"
          />
        </div>

        <div className="flex justify-center sm:justify-start">
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow"
          >
            Submit
          </button>
        </div>
      </form>

      <div className="flex justify-center my-5">
        <Link to={"/admin/ekstrakulikuler"}>
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default AddEkskul;
